import React from "react";
import { NavLink } from "react-router-dom";

const PageHeader = ({ title, crumb }) => {
  return (
    <div className="page_header d-flex align-items-center justify-content-center index-1 position-relative">
      <div className="container px-sm-2 px-4">
        <div className="page_header_content text-center">
          <h2 className="text-white fw-800">{title}</h2>
          <ul className="list-unstyled d-flex align-items-center justify-content-center gap-4">
            <li>
              <NavLink to="/" className="page_header_link">
                Home
              </NavLink>
            </li>
            <li>
              <a href="#" className="page_header_link active">
                {crumb}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
